<template>
	<div class="ss-content search-content">
		<div class="search-box clearfix">
			<input type="text" placeholder="搜索" v-model="keyword" @keyup.enter="searchConfirm" />
			<button @click="searchConfirm">
				<img src="~@/assets/img/main/search.png" />
				搜索
			</button>
		</div>
		<!-- <template v-if="finish_ && curData_.length"> -->
			<div class="ss-container">
				<ss-article-list :finish="finish_" :busy="busy_" mode="4" :value="curData_" />
			</div>
			<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
		<!-- </template>
		<template v-else>
			<div class="ss-container">
				<ss-no-data mode="image" text="没有找到相关信息" />
			</div>
		</template> -->
	</div>
</template>

<script>
	import ssArticleList from '@/components/ss-article-list/ss-article-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [listMixin],
		components: {
			ssArticleList
		},
		methods: {
			searchConfirm() {
				this.changeState(0);
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.search-content{
		background-color: #fff;
		padding-bottom: 70px;
		
		.ss-container{
			background: #FFFFFF;
			border: 1px solid #DEDEDE;
			::v-deep .no-data{
				padding: 230px 0 600px;
			}
		}
		.search-box{
			width: 784px;
			margin: 0 auto;
			padding: 40px 0 30px;
			input{
				float: left;
				width: 653px;
				height: 44px;
				line-height: 42px;
				background: #FFFFFF;
				border: 1px solid #DEDEDE;
				border-radius: 3px;
				padding: 0 13px;
			}
			button{
				width: 120px;
				height: 44px;
				font-size: 18px;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 44px;
				background: #0260FE;
				border-radius: 3px;
				float: right;
				text-align: center;
				img{
					width: 20px;
					height: 20px;
					display: inline-block;
					vertical-align: middle;
				}
			}
		}
	}
</style>
